// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1juVH","title":"InfoRow_title__v5yvy"};